import store from "@/store";

import { getMaxRecordLb } from "@/api/system";
import { checkDocumentExist } from "@/api/documentexist";
import { _updateData } from "@/api/esdata";
import { getFormOptions } from "@/api/formoptions";

export const settingZoneExplain = parentVue => {
    return {
        description:
            "<p>A <strong>ServiceGroup</strong> is a combination of <strong>SLBs</strong>, your site will map to a servicegroup before the DNS can be resolved. You can create multiple servicegroup base on your own strategy, such as <strong>GEO distribution</strong>, <strong>risk manage</strong> or even <strong>sites popularaty</strong>, it's all up to you.</p>"
    };
};

export const formSlot = parentVue => {
    return {
        onFormInit: () => {
            getMaxRecordLb({ recordType: "A" }).then(res => {
                store.commit("SET_MAX_A_RECORDS_LB", res.data.data);
            });
            getMaxRecordLb({ recordType: "CNAME" }).then(res => {
                store.commit("SET_MAX_CNAME_RECORDS_LB", res.data.data);
            });
        },
        onFormShown: formData => {}
    };
};

export const recordLineGroupName = parentVue => {
    return {
        description: "<p>The name of your recordline group, this value must be unique.</p>",
        formTypes: ["createForm"],
        formRender: "FormInput",
        validate: [
            {
                required: true,
                message: "線路分組名稱 不能為空",
                trigger: "blur"
            },
            {
                validator: (rule, value, callback, source, options) => {
                    var vm = parentVue.$refs.rcmTable;
                    if (!/^[a-z0-9\_]*$/.test(value))
                        return callback(
                            new Error(`${vm.$i18n.t("rcmtable.validateIllegalCharsPrefix")}: a-z 0-9 _`)
                        );
                    if (value.length > 35)
                        return callback(new Error(`${vm.$i18n.t("rcmtable.validateExceedLengthPrefix")}: 35`));
                    checkDocumentExist({
                        topic: "recordLineGroupId",
                        fieldVal: value,
                        groupName: vm.formData.groupName
                    }).then(result => {
                        if (!result.data.success) {
                            return callback(new Error("此線路分組名無法使用"));
                        }
                        callback();
                    });
                },
                trigger: "blur"
            }
        ]
    };
};
export const line = parentVue => {
    return {
        remoteOptions: async (queryValue, queryParams) => {
            queryValue = queryValue || "*";
            queryParams.lineName = `*${queryValue}*`;
            queryParams.optionGrouping = false;
            queryParams.withRecordLineGroups = false;
            let queryString = new URLSearchParams(queryParams).toString();
            let result = await getFormOptions(`/recordlinenames?${queryString}`);
            return result.data.options;
        }
    };
};



// WEBPACK FOOTER //
// ./src/view/RecordLineGroups/fields.js